import { render, staticRenderFns } from "./gate-link.vue?vue&type=template&id=7fce8062&scoped=true&"
import script from "./gate-link.vue?vue&type=script&lang=js&"
export * from "./gate-link.vue?vue&type=script&lang=js&"
import style0 from "./gate-link.vue?vue&type=style&index=0&id=7fce8062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce8062",
  null
  
)

export default component.exports